import React from 'react';
import { Badge } from '@/components/ui/Badge';
import { ApprovalStatus } from '../types/approvals.types';
import { 
  FileText, 
  Clock, 
  Search, 
  CheckCircle2, 
  XCircle, 
  RefreshCw, 
  Ban, 
  AlertCircle 
} from 'lucide-react';

interface ApprovalStatusBadgeProps {
  status: ApprovalStatus;
  className?: string;
}

export const ApprovalStatusBadge: React.FC<ApprovalStatusBadgeProps> = ({ status, className }) => {
  const getStatusConfig = (status: ApprovalStatus) => {
    switch (status) {
      case 'draft':
        return {
          label: 'Nháp',
          icon: FileText,
          variant: 'custom' as const,
          className: 'bg-slate-50 text-slate-600 border border-slate-200'
        };
      case 'pending':
        return {
          label: 'Chờ duyệt',
          icon: Clock,
          variant: 'custom' as const,
          className: 'bg-amber-50 text-amber-600 border border-amber-100'
        };
      case 'in_review':
        return {
          label: 'Đang xem xét',
          icon: Search,
          variant: 'custom' as const,
          className: 'bg-blue-50 text-blue-600 border border-blue-100'
        };
      case 'approved':
        return {
          label: 'Đã duyệt',
          icon: CheckCircle2,
          variant: 'custom' as const,
          className: 'bg-emerald-50 text-emerald-600 border border-emerald-100'
        };
      case 'rejected':
        return {
          label: 'Từ chối',
          icon: XCircle,
          variant: 'custom' as const,
          className: 'bg-rose-50 text-rose-600 border border-rose-100'
        };
      case 'request_change':
        return {
          label: 'Yêu cầu sửa',
          icon: RefreshCw,
          variant: 'custom' as const,
          className: 'bg-indigo-50 text-indigo-600 border border-indigo-100'
        };
      case 'cancelled':
        return {
          label: 'Đã hủy',
          icon: Ban,
          variant: 'custom' as const,
          className: 'bg-slate-100 text-slate-500 border border-slate-200'
        };
      case 'expired':
        return {
          label: 'Hết hạn',
          icon: AlertCircle,
          variant: 'custom' as const,
          className: 'bg-purple-50 text-purple-600 border border-purple-100'
        };
      default:
        return {
          label: status,
          icon: Clock,
          variant: 'custom' as const,
          className: 'bg-slate-50 text-slate-600 border border-slate-100'
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <Badge 
      variant={config.variant} 
      className={`flex items-center gap-1.5 px-2.5 py-0.5 sm:text-sm text-xs font-normal rounded-md ${config.className} ${className}`}
    >
      <Icon className="w-3.5 h-3.5" />
      <span>{config.label}</span>
    </Badge>
  );
};
